export default "__VITE_ASSET__BaHfKUNS__"